import React from 'react'
import { Link } from 'react-router-dom'

import { KTIcon } from '../../../../../_metronic/helpers'
import { SmartTooltip } from '../../../../../components/SmartTooltip/SmartTooltip'
import { DisputeTicketStatus } from '../../core/_models'
import styles from './DisputeBadge.module.css'

interface Props {
  ticketToken: string
  disputeStatus?: DisputeTicketStatus | null
  /** Ссылка в журнал только для ролей с доступом к нему (admin/manager). CPAYMENT-1615. */
  linkable?: boolean
}

/**
 * Метка принятого решения по диспуту в завершённых тикетах (CPAYMENT-1615).
 *
 * В завершённом списке важен не факт спора, а его исход: тикет закрыт решением человека, а не
 * штатным флоу — это видно сразу, без похода в журнал. Тональность повторяет исход: зелёный —
 * зачли, красный — отказали.
 *
 * Открытый диспут здесь не показываем: тикет с ним не может быть завершён.
 */
export const DisputeResolutionBadge: React.FC<Props> = ({ ticketToken, disputeStatus, linkable = false }) => {
  if (disputeStatus !== 'RESOLVED_SUCCESS' && disputeStatus !== 'RESOLVED_REJECT') {
    return null
  }

  const approved = disputeStatus === 'RESOLVED_SUCCESS'

  return (
    <SmartTooltip
      content={
        <div>
          <div className='fw-bold mb-1'>
            {approved ? 'Диспут завершён успешно' : 'По диспуту отказано'}
          </div>
          <div>
            {approved
              ? 'Спор по чеку решён в пользу зачисления — сумму подтвердил оператор.'
              : 'Спор по чеку решён отказом: тикет не зачислен и не будет зачислен автоматически, даже если оплата подтвердится позже.'}
          </div>
          {linkable && (
            <div className='mt-2 opacity-75'>Клик — журнал диспутов по этому тикету в новой вкладке.</div>
          )}
        </div>
      }
    >
      {linkable ? (
        <Link
          to={`/matching/disputes?paymentTicketToken=${ticketToken}`}
          target='_blank'
          rel='noopener noreferrer'
          className={`badge ${approved ? 'badge-light-success' : 'badge-light-danger'} d-inline-flex align-items-center gap-1 ${styles.disputeLink}`}
          aria-label='Открыть журнал диспутов по этому тикету в новой вкладке'
        >
          <KTIcon iconName='shield-cross' className='fs-7' />
          {approved ? 'Диспут: одобрен' : 'Диспут: отклонён'}
          <KTIcon iconName='exit-right-corner' className={`fs-8 ${styles.externalIcon}`} />
        </Link>
      ) : (
        <span
          className={`badge ${approved ? 'badge-light-success' : 'badge-light-danger'} d-inline-flex align-items-center gap-1`}
          style={{ cursor: 'default' }}
        >
          <KTIcon iconName='shield-cross' className='fs-7' />
          {approved ? 'Диспут: одобрен' : 'Диспут: отклонён'}
        </span>
      )}
    </SmartTooltip>
  )
}

export default DisputeResolutionBadge
